if (!customElements.get('content-with-feature-cards')) {
  customElements.define(
    'content-with-feature-cards',
    class ContentWithFeatureCards extends HTMLElement {
      constructor() {
        super();
        this.onScroll = this.onScroll.bind(this);
        this.onResize = this.onResize.bind(this);
      }

      connectedCallback() {
        this.track = this.querySelector('.content-with-feature-cards__track');
        this.progressFill = this.querySelector('.content-with-feature-cards__progress-fill');
        this.progressBar = this.querySelector('.content-with-feature-cards__progress-track');

        if (!this.track || !this.progressFill) return;

        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onResize, { passive: true });
        this.onScroll();
      }

      disconnectedCallback() {
        if (this.track) {
          this.track.removeEventListener('scroll', this.onScroll);
        }
        window.removeEventListener('resize', this.onResize);
      }

      onResize() {
        this.onScroll();
      }

      onScroll() {
        const { track, progressFill, progressBar } = this;
        const maxScroll = track.scrollWidth - track.clientWidth;

        if (maxScroll <= 0) {
          progressFill.style.width = '100%';
          this.setProgressAria(100);
          return;
        }

        const ratio = track.scrollLeft / maxScroll;
        const percent = Math.round(ratio * 100);
        progressFill.style.width = `${percent}%`;
        this.setProgressAria(percent);
      }

      setProgressAria(percent) {
        if (!this.progressBar) return;
        this.progressBar.setAttribute('aria-valuenow', String(percent));
        this.progressBar.setAttribute('aria-valuemin', '0');
        this.progressBar.setAttribute('aria-valuemax', '100');
      }
    }
  );
}
